// extracted by mini-css-extract-plugin
module.exports = {"SupplierToggle":"SupplierToggle_SupplierToggle__r6g_9","title":"SupplierToggle_title__qgkpK"};